import { render, staticRenderFns } from "./replyButton.vue?vue&type=template&id=75df1b06&"
import script from "./replyButton.vue?vue&type=script&lang=ts&"
export * from "./replyButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports